// extracted by mini-css-extract-plugin
export var component = "footer-module--component--r72Kg";
export var cube = "footer-module--cube--qVoZN";
export var link = "footer-module--link--9wwnX";
export var links = "footer-module--links--GZG0Q";
export var svg = "footer-module--svg--icd04";
export var svgs = "footer-module--svgs--CUQr6";